import React from 'react';

function AnalyticsIcon({active}) {
    return (
        <svg width="21" height="24" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line x1="1.15" y1="12.15" x2="1.15" y2="22.85" stroke={active? "white" : "black"} strokeWidth="2.3" strokeLinecap="round"/>
            <line x1="13.15" y1="7.15" x2="13.15" y2="22.85" stroke={active? "white": "black"} strokeWidth="2.3" strokeLinecap="round"/>
            <line x1="19.15" y1="17.15" x2="19.15" y2="22.85" stroke={active? "white": "black"} strokeWidth="2.3" strokeLinecap="round"/>
            <line x1="7.15" y1="1.15" x2="7.15" y2="22.85" stroke={active?"white" : "black"} strokeWidth="2.3" strokeLinecap="round"/>
        </svg>

    );
}

export default AnalyticsIcon;